var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-card",
    { staticClass: "hide-overflow", attrs: { flat: "", height: "100%" } },
    [
      _c(
        "Loading",
        {
          attrs: {
            visible: _vm.loading,
            message: "Caricamento dati...",
            templateType: _vm.loadTemplateCorrente,
          },
        },
        [
          _c(
            "v-layout",
            { staticStyle: { "margin-bottom": "50px" }, attrs: { wrap: "" } },
            [
              _c(
                "v-flex",
                {
                  staticStyle: { margin: "24px 24px 0px 24px" },
                  attrs: { xs12: "" },
                },
                [
                  _c(
                    "v-row",
                    { attrs: { "no-gutters": "" } },
                    [
                      _c(
                        "v-col",
                        {
                          staticStyle: { "padding-right": "10px" },
                          attrs: { cols: "5" },
                        },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              dense: "",
                              filled: "",
                              clearable: "",
                              label: "Stagione",
                              items: _vm.stagioni,
                              "item-value": "id",
                              "item-text": "id",
                              "data-test": "lista-stagioni",
                            },
                            model: {
                              value: _vm.stagione,
                              callback: function ($$v) {
                                _vm.stagione = $$v
                              },
                              expression: "stagione",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        [
                          _c(
                            "v-autocomplete",
                            {
                              attrs: {
                                dense: "",
                                filled: "",
                                clearable: "",
                                multiple: "",
                                label: "Tipologia",
                                items: _vm.avanzamenti,
                                "item-value": "id",
                                "item-text": "desc",
                              },
                              model: {
                                value: _vm.filtroAvanzamento,
                                callback: function ($$v) {
                                  _vm.filtroAvanzamento = $$v
                                },
                                expression: "filtroAvanzamento",
                              },
                            },
                            [_vm._v(" >")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { attrs: { "no-gutters": "" } },
                    [
                      _c(
                        "v-col",
                        {
                          staticStyle: { "padding-right": "10px" },
                          attrs: { cols: "5" },
                        },
                        [
                          _c("v-text-field", {
                            attrs: {
                              dense: "",
                              filled: "",
                              clearable: "",
                              label: "Colore",
                              "item-value": "id",
                            },
                            model: {
                              value: _vm.colore,
                              callback: function ($$v) {
                                _vm.colore = $$v
                              },
                              expression: "colore",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        [
                          _c("v-text-field", {
                            attrs: {
                              dense: "",
                              filled: "",
                              clearable: "",
                              label: "Modello",
                              "item-value": "id",
                            },
                            model: {
                              value: _vm.modello,
                              callback: function ($$v) {
                                _vm.modello = $$v
                              },
                              expression: "modello",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { attrs: { "no-gutters": "" } },
                    [
                      _c(
                        "v-col",
                        {
                          staticStyle: { "padding-right": "10px" },
                          attrs: { cols: "5" },
                        },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              dense: "",
                              filled: "",
                              clearable: "",
                              label: "Linea Vendita",
                              items: _vm.lineeVendita,
                              "item-value": "id",
                              "item-text": "id",
                              "data-test": "lista-linee-vendita",
                            },
                            model: {
                              value: _vm.lineaVendita,
                              callback: function ($$v) {
                                _vm.lineaVendita = $$v
                              },
                              expression: "lineaVendita",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    {
                      staticStyle: { "margin-top": "10px" },
                      attrs: { "no-gutters": "" },
                    },
                    [_vm._v("Con variazioni:")]
                  ),
                  _c(
                    "v-row",
                    { attrs: { "no-gutters": "" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "6" } },
                        [
                          _c(
                            "v-row",
                            { attrs: { "no-gutters": "", dense: "" } },
                            [
                              _c(
                                "v-col",
                                {
                                  staticStyle: { "margin-right": "20px" },
                                  attrs: { cols: "auto" },
                                },
                                [
                                  _c(
                                    "v-menu",
                                    {
                                      ref: "menu1",
                                      attrs: {
                                        "offset-y": "",
                                        transition: "scale-transition",
                                        "max-width": "290px",
                                        "min-width": "90px",
                                        "close-on-content-click": false,
                                        "nudge-right": 40,
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "activator",
                                          fn: function ({ on }) {
                                            return [
                                              _c(
                                                "v-text-field",
                                                _vm._g(
                                                  {
                                                    attrs: {
                                                      clearable: "",
                                                      label: "da data",
                                                      "persistent-hint": "",
                                                      "prepend-icon":
                                                        "mdi-calendar",
                                                    },
                                                    on: {
                                                      blur: function ($event) {
                                                        _vm.filtroVariazioniDa =
                                                          _vm.parseDate(
                                                            _vm.filtroVariazioniDaFormatted
                                                          )
                                                      },
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.filtroVariazioniDaFormatted,
                                                      callback: function ($$v) {
                                                        _vm.filtroVariazioniDaFormatted =
                                                          $$v
                                                      },
                                                      expression:
                                                        "filtroVariazioniDaFormatted",
                                                    },
                                                  },
                                                  on
                                                )
                                              ),
                                            ]
                                          },
                                        },
                                      ]),
                                      model: {
                                        value: _vm.menu1,
                                        callback: function ($$v) {
                                          _vm.menu1 = $$v
                                        },
                                        expression: "menu1",
                                      },
                                    },
                                    [
                                      _c("v-date-picker", {
                                        on: {
                                          input: function ($event) {
                                            _vm.menu1 = false
                                          },
                                        },
                                        model: {
                                          value: _vm.filtroVariazioniDa,
                                          callback: function ($$v) {
                                            _vm.filtroVariazioniDa = $$v
                                          },
                                          expression: "filtroVariazioniDa",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "auto" } },
                                [
                                  _c(
                                    "v-menu",
                                    {
                                      ref: "menu2",
                                      attrs: {
                                        "offset-y": "",
                                        transition: "scale-transition",
                                        "max-width": "290px",
                                        "min-width": "90px",
                                        "close-on-content-click": false,
                                        "nudge-right": 40,
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "activator",
                                          fn: function ({ on }) {
                                            return [
                                              _c(
                                                "v-text-field",
                                                _vm._g(
                                                  {
                                                    attrs: {
                                                      clearable: "",
                                                      label: "a data",
                                                      "persistent-hint": "",
                                                      "prepend-icon":
                                                        "mdi-calendar",
                                                    },
                                                    on: {
                                                      blur: function ($event) {
                                                        _vm.filtroVariazioniA =
                                                          _vm.parseDate(
                                                            _vm.filtroVariazioniAFormatted
                                                          )
                                                      },
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.filtroVariazioniAFormatted,
                                                      callback: function ($$v) {
                                                        _vm.filtroVariazioniAFormatted =
                                                          $$v
                                                      },
                                                      expression:
                                                        "filtroVariazioniAFormatted",
                                                    },
                                                  },
                                                  on
                                                )
                                              ),
                                            ]
                                          },
                                        },
                                      ]),
                                      model: {
                                        value: _vm.menu2,
                                        callback: function ($$v) {
                                          _vm.menu2 = $$v
                                        },
                                        expression: "menu2",
                                      },
                                    },
                                    [
                                      _c("v-date-picker", {
                                        on: {
                                          input: function ($event) {
                                            _vm.menu2 = false
                                          },
                                        },
                                        model: {
                                          value: _vm.filtroVariazioniA,
                                          callback: function ($$v) {
                                            _vm.filtroVariazioniA = $$v
                                          },
                                          expression: "filtroVariazioniA",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        [
                          _c(
                            "v-row",
                            {
                              attrs: {
                                justify: "end",
                                dense: "",
                                "no-gutters": "",
                              },
                            },
                            [
                              _c(
                                "v-col",
                                [
                                  _c("v-checkbox", {
                                    attrs: { label: "Da validare" },
                                    model: {
                                      value: _vm.filtroDaValidare,
                                      callback: function ($$v) {
                                        _vm.filtroDaValidare = $$v
                                      },
                                      expression: "filtroDaValidare",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                [
                                  _c("v-checkbox", {
                                    attrs: { label: "Da sincronizzare" },
                                    model: {
                                      value: _vm.filtroDraft,
                                      callback: function ($$v) {
                                        _vm.filtroDraft = $$v
                                      },
                                      expression: "filtroDraft",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                [
                                  _c("v-checkbox", {
                                    attrs: {
                                      label: "Validate e sincronizzate",
                                    },
                                    model: {
                                      value: _vm.filtroValidSync,
                                      callback: function ($$v) {
                                        _vm.filtroValidSync = $$v
                                      },
                                      expression: "filtroValidSync",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    {
                      staticStyle: { "margin-bottom": "20px" },
                      attrs: { justify: "end" },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "mx-2",
                          attrs: {
                            color: "primary",
                            large: "",
                            disabled: _vm.btnRefreshDisabled,
                            "data-test": "caricaPaginaDistinteConsumi",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.caricaPaginaDistinteConsumi(1)
                            },
                          },
                        },
                        [
                          _vm._v(" Cerca "),
                          _c("v-icon", { attrs: { dark: "" } }, [
                            _vm._v("mdi-refresh"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [_c("GruppoDistinteConsumiList")],
                1
              ),
              _c("div", { staticClass: "pagination text-xs-center" }, [
                _c("div", { staticClass: "pagination-text grey--text" }, [
                  _vm._v(" Elementi visualizzati: "),
                  _c("strong", [_vm._v(_vm._s(_vm.numTotDistinte))]),
                ]),
                _c(
                  "div",
                  { staticClass: "pagination-buttons" },
                  [
                    _c("v-pagination", {
                      attrs: { length: _vm.pageCount, disabled: _vm.loading },
                      model: {
                        value: _vm.page,
                        callback: function ($$v) {
                          _vm.page = $$v
                        },
                        expression: "page",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }